export default "__VITE_ASSET__BniRCSWe__";